import { useState } from "react";
import { Navigate } from "react-router-dom";
import { takePendingSession } from "@/practice/session-handoff";
import { Player, type PlayItem } from "@/practice/player";

/** Plays a composed Train session handed off from the Train hero. Reloading
 *  loses the in-memory session, so redirect back to /app/train. */
export function TrainPlay() {
  const [composed] = useState(() => takePendingSession());
  if (!composed) return <Navigate to="/app/train" replace />;

  const items: PlayItem[] = composed.items.map((ci) => ({
    item: ci.item,
    setId: ci.ctx.setId,
    topicSlug: ci.ctx.topicSlug,
    bulkId: ci.ctx.bulkId,
    bulkGradedSequence: ci.ctx.bulkGradedSequence,
    frameworkSlug: ci.ctx.frameworkSlug,
    sharedPassageText: ci.ctx.sharedPassageText,
  }));

  return (
    <Player
      items={items}
      anchorSetId={composed.anchorSetId ?? items[0]?.setId ?? ""}
      backTo="/app/train"
      backLabel="End"
      againTo="/app/train"
    />
  );
}
